import { render, staticRenderFns } from "./dashboardGara.vue?vue&type=template&id=6c86d083&scoped=true&"
import script from "./dashboardGara.vue?vue&type=script&lang=js&"
export * from "./dashboardGara.vue?vue&type=script&lang=js&"
import style0 from "./dashboardGara.vue?vue&type=style&index=0&id=6c86d083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c86d083",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VContainer,VFooter,VIcon,VRow,VTab,VTabItem,VTabs,VTabsItems})
